import { render } from "./BatchClassAttributesView.vue?vue&type=template&id=11f7d64e&scoped=true&ts=true"
import script from "./BatchClassAttributesView.vue?vue&type=script&lang=ts"
export * from "./BatchClassAttributesView.vue?vue&type=script&lang=ts"

import "./BatchClassAttributesView.vue?vue&type=style&index=0&id=11f7d64e&scoped=true&lang=css"

import exportComponent from "D:\\repos\\Platform\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11f7d64e"]])

export default __exports__